import {
  BaseDialog,
  SanitizedTrimmedHtml,
} from '@airship-platform/jam-web/components';
import { UniversalUpgradeProduct } from '../../data-access';

interface UpgradeSelectorModalProps {
  upgrade: UniversalUpgradeProduct | null;
  open: boolean;
  onClose: () => void;
}

const UpgradeSelectorModal: React.FC<UpgradeSelectorModalProps> = ({
  open,
  onClose,
  upgrade,
}) => {
  if (!upgrade) {
    return null;
  }

  return (
    <BaseDialog open={open} onClose={onClose} title={upgrade.name}>
      <SanitizedTrimmedHtml html={upgrade.description} />
    </BaseDialog>
  );
};

export default UpgradeSelectorModal;
